import {createUseStyles} from 'react-jss'

export default createUseStyles({
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingLeft: 50,
    paddingRight: 50,
    paddingTop: 90,
    '& section': {
      width: '100%',
      marginBottom: 10,
    }
  },

  boardsArea: {
    display: 'flex',
    paddingTop: 20,
    flexWrap: 'wrap'
  },

 
  '@media screen and (max-width: 800px)': {
    pageContainer: {
      paddingLeft: 10,
      paddingRight: 10,
    }
  
  },

  
})